(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fermata-delivery-privacy"]) return;
  try {
    
(()=>{
const init=()=>{
const template=document.querySelector('#fermata-shipping-estimates [data-shipping-estimate-template]');
const main=document.getElementById('MainContent');
if(!template||!main)return;
const place=()=>{
const button=main.querySelector('button[id^="ProductSubmitButton-"][id$="__main"]');
const block=button?.closest('block-buy-buttons');
if(block&&!block.querySelector('.fse-card')){const target=button.closest('form')?.querySelector('button[id^="ProductSubmitButton-"]')?.parentElement;if(target)target.insertAdjacentElement('afterend',template.content.firstElementChild.cloneNode(true));}
};
place();
let queued=false;
new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;place();});}).observe(main,{childList:true,subtree:true});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();

  (()=>{
    const init=()=>{
      const root=document.getElementById('fermata-delivery-privacy');
      const main=document.getElementById('MainContent');
      if(!root||!main||root.dataset.initialized)return;
      root.dataset.initialized='true';
      const template=root.querySelector('[data-privacy-inline]');
      const place=()=>{
        if(main.querySelector('[data-delivery-privacy-inline]'))return;
        const button=main.querySelector('button[id^="ProductSubmitButton-"][id$="__main"]')||main.querySelector('form[action*="/cart/add"] button[type="submit"]');
        if(!button||!template)return;
        const block=button.closest('block-buy-buttons')||button.closest('form');
        if(block)block.append(template.content.cloneNode(true));
      };
      place();
      let queued=false;
      const observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;place();});});
      observer.observe(main,{childList:true,subtree:true});
      const toast=root.querySelector('[data-privacy-toast]');
      const close=()=>{if(toast)toast.hidden=true;};
      root.querySelector('[data-privacy-close]')?.addEventListener('click',close);
      document.addEventListener('keydown',event=>{if(event.key==='Escape')close();});
      if(root.dataset.popupEnabled==='true'&&toast){
        try{
          const key='fermata-delivery-privacy-shown-v1';
          if(!sessionStorage.getItem(key)){
            sessionStorage.setItem(key,'1');
            window.setTimeout(()=>{toast.hidden=false;},1200);
          }
        }catch(error){close();}
      }
      window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
    document.addEventListener('shopify:section:load',init);
  })();

  } catch(e) { console.error(e); }
})();
})();
